import {countTasksWithin} from "./countOverallTasks"
import {meetsThreshold} from "../_common/answerValidationHelper";
import {safeVal} from "./safeVal"

const log = x => { console.log(x); return x }

export default class LueckentextValidator {
    static isAnswerCorrect(answer) {
        return answer.question().doesOrderCount() ?
               this.isCorrectWhenOrderDoesCount(answer) :
               this.isCorrectWhenOrderDoesNotCount(answer)
    }

    static isCorrectWhenOrderDoesCount(answer) {
        let userInput = answer.userInput()
        if(userInput.length<1) return false

        const optionsOf         = x => safeVal(x.value.expected).toString().trim().split(';')
        const answeredStateOf   = x => optionsOf(x).some( y => y.trim() === safeVal(x.value.given).toString().trim())
        const mapToAnswerStates = ui => ui.map(answeredStateOf)

        const countAnswered     = () => mapToAnswerStates(userInput).length
        const countAll          = () => countTasksWithin(answer)
        const countCorrectOnes  = () => mapToAnswerStates(userInput).filter( x => x===true ).length
        const areAllAnswered    = () => countAnswered()===countAll()
        const areAllCorrect     = () => mapToAnswerStates(userInput).every(  x => x===true )

        return (!answer.countPerAnswer())   ? (areAllCorrect() && areAllAnswered())
                                            : meetsThreshold(countCorrectOnes(), countAll())
    }

    static isCorrectWhenOrderDoesNotCount(answer) {
        const userInput             = answer.userInput()
        const correctAnswers        = answer.question().correctAnswers()
        const doesCountPerAnswer    = answer.countPerAnswer()

        if(userInput.length<1)
            return false

        const answersAreEqual   = (ca,ui) => ca.toString().trim() === safeVal(ui.value.given).toString().trim()
        const correctCount      = userInput.map( ui =>
                    correctAnswers.filter( ca => answersAreEqual(ca,ui) ).length > 0
                )
                .filter( x => x===true )
                .length
        const maxCount          = correctAnswers.length

        return !doesCountPerAnswer  ? (correctCount===maxCount)
                                    : meetsThreshold(correctCount, maxCount)
    }
}
